/* global Sys, Core */
Sys.ns("Core");

Core._DeviceDetectionUtils = (function() {
    return {

        /**
         * Checks if a string is a valid version number.
         *
         * @static
         * @param {string} version The version number.
         * @returns {boolean} Whether or not the string is a valid version number.
         */
        isVersionNumber: function(version) {
            return (/^\d+(\.\d+){0,2}$/).test(version);
        },

        /**
         * Compares the two versions for order.
         *
         * @static
         * @param {string} a The first object to be compared.
         * @param {string} b The second object to be compared.
         * @throws {Error} Throws an error if any of the versions are invalid.
         * @returns {number} A negative integer, zero, or a positive integer as the first argument is less than, equal to, or greater than the second.
         */
        compareVersions: function(a, b) {
            var i,
                aPart,
                bPart,
                aParts,
                bParts;

            if (!Core._DeviceDetectionUtils.isVersionNumber(a) || !Core._DeviceDetectionUtils.isVersionNumber(b)) {
                throw new Error("The versions provided are not valid versions");
            }

            aParts = a.split(".").map(parseFloat);
            bParts = b.split(".").map(parseFloat);

            while (aParts.length < bParts.length) {
                aParts.push(0.0);
            }

            while (bParts.length < aParts.length) {
                bParts.push(0.0);
            }

            for (i = 0; i < aParts.length; i++) {
                aPart = aParts[i];
                bPart = bParts[i];
                if (aPart === bPart) {
                    continue;
                }
                return aPart < bPart ? -1 : 1;
            }

            return 0;
        },

        /**
         * Checks if a version is in range.
         *
         * @static
         * @param {string} version - The actual version.
         * @param {string} [min] - The minimum allowed version.
         * @param {string} [max] - The maximum allowed version.
         * @returns {boolean} - Whether or not the version is within the range.
         */
        isInRange: function(version, min, max) {
            var aboveOrEqToMin = true,
                belowOrEqToMax = true;

            if (min && Core._DeviceDetectionUtils.compareVersions(version, min) < 0) {
                aboveOrEqToMin = false;
            }

            if (max && Core._DeviceDetectionUtils.compareVersions(version, max) > 0) {
                belowOrEqToMax = false;
            }

            return aboveOrEqToMin && belowOrEqToMax;
        }
    };
}());
